import axios from 'axios';

export const USER_SIGNED_UP = 'USER_SIGNED_UP';
export const USER_SIGNUP_ERROR = 'USER_SIGNUP_ERROR';

const signUp = data => (
  dispatch => (
    axios.post('/api/signup', data).then((response) => {
      dispatch({
        type: USER_SIGNED_UP,
        user: response.data.data,
      });

      return true;
    }).catch((error) => {
      dispatch({
        type: USER_SIGNUP_ERROR,
        message: error.response.data.message,
        errors: error.response.data.errors,
      });

      return false;
    })
  )
);

export default signUp;
